<h2 class="ticket__outside-header" aria-hidden="true">
	<span skeletonLoader [translationKey]="INDRA_printDaysLabel()">
		{{INDRA_printDaysCount()}}
		{{INDRA_printDaysLabel() | ibeadmin | async}}
		<strong>{{INDRA_printStopoverDestination()}}</strong>
	</span>
</h2>

<article class="ticket-wrapper ticket vertical" [attr.aria-label]=INDRA_printAriaStopover() role="article" tabindex="-1">

	<div class="top"[style.background-image]="INDRA_printDestinationImage()" aria-hidden="true">
		<img class="destination-logo" type="image/svg+xml" [src]="INDRA_printDestinationLogo()">
	</div>

	<div class="tear-here" aria-hidden="true">
		<div class="left"></div>
		<div class="divider-dashed"></div>
		<div class="right"></div>
	</div>

	<div class="bottom">
		<h3 class="title-h3">{{ INDRA_getStopoverHashtag() }}</h3>

		<ul class="body expanded see-less extras-add" *ngIf="!loading_extras">
			<li *ngFor="let feature of INDRA_getFeatures()" class="extras-feature" [class.updated]="feature.active">
				<app-svg *ngIf="INDRA_hasIcon(feature)" 
					alt="{{feature.label | ibeadmin | async}}" 
					[ngClass]="['extras-feature__icon']" 
					svg="icons.svg#{{feature.icon || 'general--plus'}}"
					attr.tooltip="{{feature.label | ibeadmin | async}}">
				</app-svg>
				<div class="extras-feature__label">
					<span [ngClass]="{ 'highlighted': INDRA_isActive(feature)  }">
						<span skeletonLoader [translationKey]="feature.label">
							{{feature.label | ibeadmin | async}}
						</span>
					</span>
					<span class="muted" *ngIf="INDRA_isActive(feature)">{{feature.value | indracurrency : currency }}
					</span>
				</div>
				<button *ngIf="feature.action && INDRA_isActive(feature); else actionLabel"
					(click)="INDRA_handleOpenExtra(feature.action,'edit', feature.name)" class="extras-feature__link link edit-feature"
					[attr.aria-label]="'Edit ' + feature.label + ', open dialog'">
					<span class="hidden-mobile">Edit</span>
					<app-svg aria-hidden="true" class="hidden-tablet-portrait-up" svg="icons.svg#general--edit"
						[alt]="'Edit icon'"></app-svg>
				</button>
				<ng-template #actionLabel>
					<button *ngIf="feature.action" (click)="INDRA_handleOpenExtra(feature.action,'add', feature.name)"
						class="button button--small extras-feature__button"
						[attr.aria-label]="feature.action.label+ ' ' + feature.label + ', open dialog'">
						<span class="hidden-mobile" skeletonLoader [translationKey]="feature.action.label">
							{{feature.action.label | ibeadmin | async}}
						</span>
						<app-svg aria-hidden="true" class="hidden-tablet-portrait-up" svg="icons.svg#general--plus_2"
						[alt]="'Edit icon'"></app-svg>
					</button>
				</ng-template>
				
				<a *ngIf="feature.details" 
					(click)="INDRA_goToUrl(feature.details.route)" href ="javascript:;"
					class="link link--external extras-feature__link" 
					[attr.aria-label]="('bookingDetails.title.openNewWindow' | ibeadmin | async) + ' ' + (feature.details.label | ibeadmin | async) "
				>
					<span skeletonLoader [translationKey]="feature.details.label">
						{{feature.details.label | ibeadmin | async}}
					</span>
				</a>
				<!-- TODO implement this (and replace the link above)
				<a *ngIf="feature.details" (click)="TAP_handleOpenExtraDetails(feature.details)"
					class="link link--external extras-feature__link" [attr.aria-label]="feature.details.label+ ', open dialog'"
					href="javascript:;" role="button">{{feature.details.label}}</a>
				-->
			</li>
		</ul>
		<ul class="body expanded see-less extras-add" *ngIf="loading_extras">
			<app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
			<app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
			<app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
		</ul>
	</div>
</article>
